import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "item" ];
  activeSlide;
  yDown;
  lastEvent;
  mainElement;

  connect() {
    this.activeSlide = 0;
    this.xDown = null;
    this.yDown = null;
    this.lastEvent = new Date();
    this.waitForViewport = true;
    this.mainElement = document.getElementById("main");

    this.mainElement.addEventListener("wheel", this.wheel.bind(this));
    this.mainElement.addEventListener("touchstart", this.touchstart.bind(this));
    this.mainElement.addEventListener("touchmove", this.touchmove.bind(this));
  }

  disconnect() {
    this.mainElement.removeEventListener("wheel", this.wheel.bind(this));
    this.mainElement.removeEventListener("touchstart", this.touchstart.bind(this));
    this.mainElement.removeEventListener("touchmove", this.touchmove.bind(this));
  }

  wheel(e) {
    const delta = Math.sign(e.deltaY);
    const enable = this.activeSlide + delta;

    if (!this.isInViewport()) {
      return;
    }

    if (this.wouldScroll(enable) && !this.checkTime()) {
      e.preventDefault();
      return;
    }

    if (this.swapState(enable)) {
      e.preventDefault();
    }
  }

  touchstart(e) {
    this.yDown = e.changedTouches[0].clientY;
  }

  touchmove(e) {
    if (this.yDown === null) {
      return;
    }

    if (!this.isInViewport()) {
      return;
    }

    const delta = Math.sign(this.yDown - e.changedTouches[0].clientY);
    const enable = this.activeSlide + delta;

    if (this.wouldScroll(enable) && !this.checkTime()) {
      this.element.scrollIntoView({ behavior: 'smooth', block: 'center'});
      e.preventDefault();
      return;
    }

    if (this.swapState(enable)) {
      e.preventDefault();
    }
  }

  isInViewport() {
    let { top, bottom } = this.element.getBoundingClientRect();
    return top >= -300 && top <= 300;
  }

  wouldScroll(enable) {
    return enable >= 0 && enable < this.itemTargets.length;
  }

  swapState(enable) {
    if (this.wouldScroll(enable)) {
      this.itemTargets[this.activeSlide].classList.remove('active');
      this.itemTargets[enable].classList.add('active');
      this.activeSlide = enable;
      return true;
    }
    return false;
  }

  checkTime() {
    let now = new Date();
    let timeDiff = now - this.lastEvent;
    if (timeDiff > 1000) {
      this.lastEvent = now;
      return true;
    }

    return false;
  }


  show(event) {
    event.preventDefault();
    this.swapState(parseInt(event.currentTarget.dataset.show, 10));
  }
}
